(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduced.matches || !('IntersectionObserver' in window)) return;
  const sectionSelector = 'main .shopify-section';
  const contentSelector = [
    'h1', 'h2', 'h3',
    '.rte > p', '.rte > ul', '.rte > ol',
    '.subtitle', '.section-header__subheading',
    '.banner__text', '.image-with-text__text',
    '.multicolumn-card', '.card-wrapper',
    '.collection-list__item', '.blog__post',
    '.academy-left .glass-card', '.academy-right > img',
    '.lash-section > .page-width > .subtitle',
    '.lash-section > .page-width > h2',
    '.custom-card', '.feature-card',
    '.image-with-text__media-item', '.multirow__inner > *'
  ].join(',');
  const mobileSelector = [
    '.lash-card', '.video-item', '.icon-with-text-item .icon-text',
    '.multicolumn-card__info', '.custom-card__media',
    '.custom-card__text', '.collection__title .subtitle',
    '.title-wrapper-with-link .subtitle', '.section-header .subtitle',
    '.academy-buttons .button', '.academy-right > img',
    '.testimonials-slider__text', '.vp-review-source-logos',
    '.rich-text__text', '.image-banner__text',
    '.product-grid .card-wrapper', '.collection-list .card-wrapper',
    '.collage-card', '.tzn-team-card'
  ].join(',');
  const skip = 'header, footer, .slideshow__slide, .product__media-list, .product-form, .facets, .modal, .drawer';
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      entry.target.classList.add('vp-visible');
      observer.unobserve(entry.target);
    }
  }, { threshold: 0.08, rootMargin: '0px 0px -35px 0px' });

  function prepare(root = document) {
    const sections = root.matches?.(sectionSelector) ? [root] : root.querySelectorAll(sectionSelector);
    for (const section of sections) {
      if (section.matches('[id*="header"], [id*="footer"], [id*="announcement"]')) continue;
      const nodes = Array.from(section.querySelectorAll(window.matchMedia('(max-width: 749px)').matches ? `${contentSelector},${mobileSelector}` : contentSelector));
      let order = 0;
      for (const node of nodes) {
        if (node.closest(skip) || node.closest('.vp-reveal') || node.matches('[hidden], [aria-hidden="true"]')) continue;
        const paragraph = node.matches('.rte > p, .rte > ul, .rte > ol');
        if (node.classList.contains('scroll-trigger')) continue;
        if (node.closest('.scroll-trigger') && !paragraph) continue;
        if (node.matches('.image-with-text__text, .rich-text__text, .banner__text') && node.querySelector('p, ul, ol')) continue;
        if (node.matches('.swiper-slide, .slider__slide, .grid__item')) continue;
        if (node.getBoundingClientRect().width === 0 || node.getBoundingClientRect().height === 0) continue;
        const rect = node.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.9 && rect.bottom > 0) continue;
        const isText = node.matches('.rte > p, .rte > ul, .rte > ol, .banner__text, .image-with-text__text, .custom-card__text, .rich-text__text, .image-banner__text, .icon-text, .multicolumn-card__info');
        const isMedia = node.matches('.image-with-text__media-item, .academy-right > img, .video-item, .custom-card__media');
        node.classList.add('vp-reveal');
        if (isText) node.classList.add('vp-reveal--text');
        if (isMedia) node.classList.add('vp-reveal--media');
        const textIndex = paragraph ? Array.from(node.parentElement.children).filter(child => child.matches('p, ul, ol')).indexOf(node) : -1;
        const delay = textIndex >= 0 ? Math.min(textIndex, 4) * (window.innerWidth < 750 ? 280 : 200) : Math.min(order % 4, 3) * (window.innerWidth < 750 ? 65 : 85);
        node.style.setProperty('--vp-motion-delay', `${delay}ms`);
        order++;
        observer.observe(node);
      }
    }
    document.documentElement.classList.add('vp-motion-ready');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => prepare(), { once: true });
  else prepare();
  document.addEventListener('shopify:section:load', (event) => prepare(event.target));
  reduced.addEventListener('change', (event) => {
    if (event.matches) {
      observer.disconnect();
      document.querySelectorAll('.vp-reveal').forEach(node => node.classList.add('vp-visible'));
    }
  });
})();
